
export default function (Component) {
  Component.options.__source = "src/components/flexbox/flexbox.vue"
}
